/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Cta_MoreInputs */

const en_mk_price_cta_more = /** @type {(inputs: Mk_Price_Cta_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See full pricing details`)
};

const id_mk_price_cta_more = /** @type {(inputs: Mk_Price_Cta_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat detail harga`)
};

/**
* | output |
* | --- |
* | "See full pricing details" |
*
* @param {Mk_Price_Cta_MoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_cta_more = /** @type {((inputs?: Mk_Price_Cta_MoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Cta_MoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_cta_more(inputs)
	return en_mk_price_cta_more(inputs)
});